import PropTypes from 'prop-types'

export const deviceTypes = PropTypes.oneOf(['mobile', 'desktop'])

export const screenSizes = PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])

export const stringOrNumber = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number
])

export const alignmentTypes = PropTypes.oneOf(['left', 'center', 'right'])

export const applicationStateShape = PropTypes.shape({
  advancedPurchase: PropTypes.number,
  amount: PropTypes.string,
  currency: PropTypes.string,
  departingDate: PropTypes.string,
  destination: PropTypes.string,
  destinationAirportCode: PropTypes.string,
  device: deviceTypes,
  endDate: PropTypes.string,
  flyEndDate: PropTypes.string,
  flyStartDate: PropTypes.string,
  flyConfirmationNumber: PropTypes.string,
  lang: PropTypes.string,
  numAdults: PropTypes.number,
  numPassengers: PropTypes.number,
  orderId: PropTypes.string,
  origin: PropTypes.string,
  originAirportCode: PropTypes.string,
  pageType: PropTypes.string,
  random: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.number
})

export const headerLinkShape = PropTypes.shape({
  label: PropTypes.string,
  href: PropTypes.string,
  iconName: PropTypes.string
})

export const headerNavigationShape = PropTypes.shape({
  label: PropTypes.string,
  href: PropTypes.string,
  iconName: PropTypes.string,
  links: PropTypes.arrayOf(headerLinkShape),
  isMobileOnly: PropTypes.bool
})

export const largeHeaderShape = PropTypes.shape({
  minBreakpoint: screenSizes,
  height: stringOrNumber,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  dropdownColor: PropTypes.string,
  linkAlignment: alignmentTypes
})

export const smallHeaderShape = PropTypes.shape({
  minBreakpoint: screenSizes,
  height: stringOrNumber,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  dropdownColor: PropTypes.string,
  menuColor: PropTypes.string,
  menuHeaderColor: PropTypes.string,
  menuBackgroundColor: PropTypes.string,
  menuButtonAlignment: PropTypes.string,
  logoAlignment: alignmentTypes
})

export const headerShape = PropTypes.shape({
  logoPath: PropTypes.string,
  logoHref: PropTypes.string,
  logoTitle: PropTypes.string,
  secondaryLogoPath: PropTypes.string,
  secondaryLogoHref: PropTypes.string,
  secondaryLogoTitle: PropTypes.string,
  linksOpenNewTab: PropTypes.bool,
  large: largeHeaderShape,
  small: smallHeaderShape,
  navigation: PropTypes.arrayOf(headerNavigationShape)
})

export const configShape = PropTypes.shape({
  header: headerShape
})

export const partnerShape = PropTypes.shape({
  config: configShape
})
